import React from 'react';
import { Button } from 'rsuite';
import styled, { css } from 'styled-components';
import * as viewer from './property-details-pdf-view-styles';

// import { useReactToPrint } from 'react-to-print';

/**
 * The PDFs generated by the listing scraper are sized in A4,
 *  so we want to re-print to A4
 */
// const pageStyle = `
//   @page {
//     size: A4;
//   }
// `;

const sharedButtonStyle = css`
  width: 100px;
`;

// const PrintButton = styled(Button)`
//   ${sharedButtonStyle}
//   margin-right: 20px;
// `;

const DownloadButton = styled(Button)`
  ${sharedButtonStyle}
`;

/**
 * Footer portion of the modal. Defines two buttons 1) Print 2) Download
 * Print triggers the printMode which triggers react-to-print
 * Download has an a href inside with download attr
 *
 * @param {*} props
 * @returns Footer portion of Modal
 */
function PDFModalFooter(props) {
  const {
    onDownloadClick,
    pdfFilePath,
    // loading,
    // printContentRef,
    // setPrintModeBefore,
    // setPrintModeAfter,
    // setPrintLoading,
  } = props;

  // // This provides a nice visual affect for loading print.
  // const delayLoaderStop = useCallback(() => {
  //   setTimeout(() => { setPrintLoading(); }, 400);
  // }, [setPrintLoading]);

  // const onClick = useReactToPrint({
  //   pageStyle,
  //   suppressErrors: true,
  //   content: () => printContentRef,
  //   onBeforePrint: () => {
  //     delayLoaderStop();
  //     setPrintModeBefore();
  //   },
  //   onAfterPrint: setPrintModeAfter,
  // });

  return (
    <viewer.FooterWrapper>
      {/* <PrintButton appearance="ghost" loading={loading} onClick={onClick}>
        Print
      </PrintButton> */}
      <DownloadButton appearance="primary" onClick={onDownloadClick}>
        <viewer.StyledDownloadText href={pdfFilePath} download />
      </DownloadButton>
    </viewer.FooterWrapper>
  );
}

export default PDFModalFooter;
